<div class="portal-selector-container">
  <div class="portal-selector-card">
    <h2 class="portal-selector-title">Select a Portal</h2>
    <p class="portal-selector-subtitle">You have access to multiple portals. Please select one to continue.</p>
    
    <div class="portal-list">
      @for (portal of context().portals; track portal.portalId) {
        <button
          class="portal-card"
          (click)="onPortalSelect(portal.name)"
          type="button">
          <div class="portal-card-content">
            <h3 class="portal-name">{{ getPortalDisplayName(portal.name) }}</h3>
            @if (portal.roles && portal.roles.length > 0) {
              <div class="portal-roles">
                <span class="role-label">Roles:</span>
                <span class="role-list">{{ portal.roles.join(', ') }}</span>
              </div>
            }
          </div>
          <div class="portal-card-arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </div>
        </button>
      }
    </div>
  </div>
</div>
